webpackJsonp([114276838955818,60335399758886],{

/***/ 123:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Brittney Brewer Dance","description":"Brittney Brewer Dance website"}}},"layoutContext":{}}

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(262);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(123);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(57);
	var isArguments = __webpack_require__(56);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 56:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(68);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(55);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(67);
	
	var _HelmetConstants = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(3);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(58));
	var shallowEqual = _interopDefault(__webpack_require__(70));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 380:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	    return _react2.default.createElement(
	        'footer',
	        { id: 'footer', style: props.timeout ? { display: 'none' } : {} },
	        _react2.default.createElement(
	            'p',
	            { className: 'copyright' },
	            '\xA9 Brittney Brewer Dance'
	        )
	    );
	};
	
	Footer.propTypes = {
	    timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	    return _react2.default.createElement(
	        'header',
	        { id: 'header', style: props.timeout ? { display: 'none' } : {} },
	        _react2.default.createElement(
	            'div',
	            { className: 'logo' },
	            _react2.default.createElement('span', { className: 'brittdance-icon' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	                'div',
	                { className: 'inner' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Brittney Brewer'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'I am a champion for the voice of an individual'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;', onClick: function onClick() {
	                                props.onOpenArticle('philosophy');
	                            } },
	                        'Philosophy'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;', onClick: function onClick() {
	                                props.onOpenArticle('work');
	                            } },
	                        'Work'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;', onClick: function onClick() {
	                                props.onOpenArticle('about');
	                            } },
	                        'About'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;', onClick: function onClick() {
	                                props.onOpenArticle('contact');
	                            } },
	                        'Contact'
	                    )
	                )
	            )
	        )
	    );
	};
	
	Header.propTypes = {
	    onOpenArticle: _react2.default.PropTypes.func,
	    timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(118);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _pic = __webpack_require__(186);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(480);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _pic5 = __webpack_require__(481);
	
	var _pic6 = _interopRequireDefault(_pic5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Main = function (_React$Component) {
	  _inherits(Main, _React$Component);
	
	  function Main() {
	    _classCallCheck(this, Main);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Main.prototype.render = function render() {
	    var _this2 = this;
	
	    var close = _react2.default.createElement('div', { className: 'close', onClick: function onClick() {
	        _this2.props.onCloseArticle();
	      } });
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'main', style: this.props.timeout ? { display: 'flex' } : { display: 'none' } },
	      _react2.default.createElement(
	        'article',
	        { id: 'philosophy', className: (this.props.article === 'philosophy' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'Philosophy'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image main' },
	          _react2.default.createElement('img', { src: _pic2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement('a', { id: 'Teaching_Philosophy_0' }),
	          'Teaching Philosophy'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I am a champion for the voice of an individual. In my classroom, I maintain a spirit of freedom in an environment that is inviting and welcoming to learners of dance of all ages, from all backgrounds, with all levels of life and dance experience, all with uniquely designed futures ahead.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I strive to maintain a dance room that is free of judgement. My learners are welcome to come as they are, and leave whatever they wish behind. My goal is to inspire creativity, individual thinking, and a mindset to never stop discovering and growing.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Some people are born to inspire others with movement in front of crowds of thousands. Some people are born to inspire classrooms of twenty. Some people are lucky enough to have experienced both. I will strive to allow my students to realize their personal goals on and off the stage, in and out of the classroom. Each student will set an intention, either aloud or in a journal, and set an overall goal for the month. We will revisit these goals monthly and evaluate where we need to focus our time, energy, and attention as a team. We will lean on one another, and reach our goals both as a classroom unit and as individuals.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I value preparedness: I will arrive to class ready to teach my students, ready to learn from my students, and ready to create with my students. Any opportunity to share the floor will be held with the upmost respect. While using a preexisting syllabus and lesson plan, I will remain flexible and present in the moment, and allow the class to proceed at a natural pace. In my opinion, part of making a perfect plan of action is allowing that plan to unfold differently than anticipated.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I value being present: In my life, my dance teacher was far more than a dance teacher. She was a mentor. She was a mom. She was a friend. She was a doctor. She was an expert. She was a therapist. I am so honored to be able to carry that tradition to my students. I will be there for them, open and ready to learn and share.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'It is my goal to inspire students to become better dancers, better sons and daughters, better friends, better parents,  better cohabitants of the earth, and better people, who continue to grow every single day.'
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        'article',
	        { id: 'work', className: (this.props.article === 'work' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'Work'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image main' },
	          _react2.default.createElement('img', { src: _pic4.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement('a', { id: 'Resume_0' }),
	          'Resume'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement('a', { id: 'Performance_Experience_2' }),
	          'Performance Experience'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Atmosphere Performer/Dancer/Improv Actor'
	          )
	        ),
	        _react2.default.createElement(
	          'table',
	          { className: 'table table-striped table-bordered' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Gaylord Palms Resort'
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Princess Fiona'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Nickelodeon Suites Resorts'
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Team Nick, Celebrate Nickmas, Bikini Bottom Breakfast, Krabby Patty Celebration, Dora\u2019s Friendship Fiesta, Ninja Turtle EventsTeam Nick, Celebrate Nickmas, Bikini Bottom Breakfast, Krabby'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Nickelodeon Suites Resorts'
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Power Ranger Event, Yellow Ranger High Voltage Extreme Street Beats, Universal Studios- Tap Dancer'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Sea World\u2019s Halloween Spooktacular'
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Odd-O-Ts\u2019 Entertainment- Sea Star'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Sea World\u2019s Christmas Celebration'
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Odd-O-Ts\u2019 Entertainment- Polar Express Elf'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Murder Mystery, Inc'
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Improv Actor & Tap Dancer'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Character Animation'
	          )
	        ),
	        _react2.default.createElement(
	          'table',
	          { className: 'table table-striped table-bordered' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Gaylord Palms Resort'
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Animated Dancer'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Universal Studios Florida'
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Animated Dancer, HOP'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Universal Studios Florida'
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Animated Street Star'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Nickelodeon Suites Resorts'
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Animated Character/ Dancer'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Puppetry'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '| Nickelodeon Suites Resorts | |'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Theatre'
	          )
	        ),
	        _react2.default.createElement(
	          'table',
	          { className: 'table table-striped table-bordered' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'TITLE'
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'ROLE'
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'COMPANY/DIRECTOR'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Proof'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Catherine'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Day & Night Theatre Co.'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Barefoot in the Park'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Mother'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Day & Night Theatre Co.'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Thoroughly Modern Millie'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Ms. Flannery, Pearl Lady'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Laura Carroll, Kathy Hudnall'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Pirates and Princess'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Dancer, Chorus'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Laura Carroll, Kathy Hudnall'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Back to the 80\u2019s'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Laura, Debbie, Chorus'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Laura Carroll, Kathy Hudnall'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'An Enchanted Christmas'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Cindy Lou Who'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Laura Carroll, Kathy Hudnall'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Frazzled Fairy Tales'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Little Red Riding Hood'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Laura Carroll, Kathy Hudnall'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Grease'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Dancer'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Sherry Febles'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Damn Yankees'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Dancer'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Sherry Febles'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'The Jungle Book'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Monkey/Dari'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Mary Wilson'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement('a', { id: 'ChoreographyTeaching_41' }),
	          'Choreography/Teaching'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Williamson County Parks & Recreation: Rhythm & Spirit Program'
	          ),
	          _react2.default.createElement('br', null),
	          'Ballet, Tap, Jazz, Tumbling, Cheer, Hip Hop, Mommy & Me Tumbling',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            'New Vision Baptist Church\u2019s Praise & Dance Team'
	          ),
	          _react2.default.createElement('br', null),
	          'Director and Choreographer',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Preschool Tumbling independently at various preschools in Rutherford and Williamson Counties'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            'SADM Certified Teaching Licenses'
	          ),
	          _react2.default.createElement('br', null),
	          'Tap, Jazz, Acrobatics',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Broadway Bound Theater & Dance Camps'
	          ),
	          ' Choreographer Columbia State Community College'
	        ),
	        _react2.default.createElement(
	          'table',
	          { className: 'table table-striped table-bordered' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'SCMS Dance Team'
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Choreographer'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Stewarts Creek Middle School'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Aladdin Junior'
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Choreographer'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Stewarts Creek Middle School'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'The Music Man'
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Choreographer'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Stewarts Creek Middle School'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement('a', { id: 'Training_57' }),
	          'Training'
	        ),
	        _react2.default.createElement(
	          'table',
	          { className: 'table table-striped table-bordered' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Jazz'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Southern Association of Dance Masters-20yrs'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Ballet'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'MTSU Meg Brooker, Jen Macnamara ******'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                'Southern Association of Dance Masters-20yrs'
	              ),
	              _react2.default.createElement('td', null)
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Modern'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'MTSU Marsha Barsky'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Tap'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Southern Association of Dance Masters-20yrs'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Lyrical'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Southern Association of Dance Masters-17yrs ******'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Vocal'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Cathy Hudnell (CSCC) 4yrs'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Acting/Theatre'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Crosby Hunt (MTSU) 4ys Paul Clapper (CSCC) 4yrs'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Hip Hop'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Southern Association of Dance Masters- 10yrs'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement('a', { id: 'Special_Skills_69' }),
	          'Special Skills'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Acrobatics (Back Walkover, Split Rolls, Head Stand, Hand Stand, Front Handsprings/ Flip flop, Round-off, Cartwheels etc.), Puppetry, Roller Skating/ Blading, Stagecraft Courses at MTSU and CSCC, Wardrobe and Costuming at MTSU and CSCC, Basic Stilts, Silk Hammock Training, Yoga Training'
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        'article',
	        { id: 'about', className: (this.props.article === 'about' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'About'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image main' },
	          _react2.default.createElement('img', { src: _pic6.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Upon graduating college in 2009 with an Associates Degree in Commercial Entertainment, and a Certificate in Dance, Brittney moved to Orlando, Florida to pursue a career in Dance and Entertainment. There she worked for Walt Disney World, Nickelodeon Suites Resorts, Sea World, Universal Studios, and Gaylord Palms Entertainment, specializing in character work, puppetry, and atmosphere improvisation acting. Ready to fulfill a lifelong dream of dance instruction, Brittney moved back home to Murfreesboro, Tennessee and began working for the Williamson County Parks and Recreation\u2019s Rhythm and Spirit Program. She currently teaches Ballet, Tap, Jazz, Cheer, Tumble, and Hip Hop classes. Recently, she graduated from Middle Tennessee State University with her Bachelors Degree in Dance. Dancing is her passion, children are her heart.'
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        'article',
	        { id: 'contact', className: (this.props.article === 'contact' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'Contact'
	        ),
	        _react2.default.createElement(
	          'form',
	          { method: 'post', action: '#' },
	          _react2.default.createElement(
	            'div',
	            { className: 'field half first' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'name' },
	              'Name'
	            ),
	            _react2.default.createElement('input', { type: 'text', name: 'name', id: 'name' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field half' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'email' },
	              'Email'
	            ),
	            _react2.default.createElement('input', { type: 'text', name: 'email', id: 'email' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'message' },
	              'Message'
	            ),
	            _react2.default.createElement('textarea', { name: 'message', id: 'message', rows: '4' })
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'actions' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('input', { type: 'submit', value: 'Send Message', className: 'special' })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('input', { type: 'reset', value: 'Reset' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'icons' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.twitter.com/brittney_dance', className: 'icon fa-twitter' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Twitter'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.instagram.com/ilvlcy', className: 'icon fa-instagram' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Instagram'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.facebook.com/brittney.laura.brewer', className: 'icon fa-facebook' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'Facebook'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.linkedin.com/in/brittney-brewer', className: 'icon fa-linkedin' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'LinkedIn'
	              )
	            )
	          )
	        ),
	        close
	      )
	    );
	  };
	
	  return Main;
	}(_react2.default.Component);
	
	Main.propTypes = {
	  route: _react2.default.PropTypes.object,
	  article: _react2.default.PropTypes.string,
	  articleTimeout: _react2.default.PropTypes.bool,
	  onCloseArticle: _react2.default.PropTypes.func,
	  timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic01.55e1797f.jpg";

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic03.5c0a1a64.jpg";

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(380);
	
	var _reactHelmet = __webpack_require__(66);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(260);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Main = __webpack_require__(261);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Footer = __webpack_require__(259);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _brittneyBrewerBalletJimani = __webpack_require__(482);
	
	var _brittneyBrewerBalletJimani2 = _interopRequireDefault(_brittneyBrewerBalletJimani);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template(props) {
	    _classCallCheck(this, Template);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isArticleVisible: false,
	      timeout: false,
	      articleTimeout: false,
	      article: '',
	      loading: 'is-loading'
	    };
	    _this.handleOpenArticle = _this.handleOpenArticle.bind(_this);
	    _this.handleCloseArticle = _this.handleCloseArticle.bind(_this);
	    return _this;
	  }
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.timeoutId = setTimeout(function () {
	      _this2.setState({ loading: '' });
	    }, 100);
	  };
	
	  Template.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.timeoutId) {
	      clearTimeout(this.timeoutId);
	    }
	  };
	
	  Template.prototype.handleOpenArticle = function handleOpenArticle(article) {
	    var _this3 = this;
	
	    this.setState({
	      isArticleVisible: !this.state.isArticleVisible,
	      article: article
	    });
	
	    setTimeout(function () {
	      _this3.setState({
	        timeout: !_this3.state.timeout
	      });
	    }, 325);
	
	    setTimeout(function () {
	      _this3.setState({
	        articleTimeout: !_this3.state.articleTimeout
	      });
	    }, 350);
	  };
	
	  Template.prototype.handleCloseArticle = function handleCloseArticle() {
	    var _this4 = this;
	
	    this.setState({
	      articleTimeout: !this.state.articleTimeout
	    });
	
	    setTimeout(function () {
	      _this4.setState({
	        timeout: !_this4.state.timeout
	      });
	    }, 325);
	
	    setTimeout(function () {
	      _this4.setState({
	        isArticleVisible: !_this4.state.isArticleVisible,
	        article: ''
	      });
	    }, 350);
	  };
	
	  Template.prototype.render = function render() {
	    var siteTitle = this.props.data.site.siteMetadata.title;
	    var siteDescription = this.props.data.site.siteMetadata.description;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'body ' + this.state.loading + ' ' + (this.state.isArticleVisible ? 'is-article-visible' : '') },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          siteTitle
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: siteDescription })
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        _react2.default.createElement(_Header2.default, { onOpenArticle: this.handleOpenArticle, timeout: this.state.timeout }),
	        _react2.default.createElement(_Main2.default, {
	          isArticleVisible: this.state.isArticleVisible,
	          timeout: this.state.timeout,
	          articleTimeout: this.state.articleTimeout,
	          article: this.state.article,
	          onCloseArticle: this.handleCloseArticle
	        }),
	        _react2.default.createElement(_Footer2.default, { timeout: this.state.timeout })
	      ),
	      _react2.default.createElement('div', { id: 'bg' }),
	      _react2.default.createElement(
	        'video',
	        { id: 'bgVideo', autoPlay: true, loop: true, poster: '../images/bg.jpg' },
	        _react2.default.createElement('source', { src: _brittneyBrewerBalletJimani2.default, type: 'video/webm' })
	      )
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = Template;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/brittney-brewer-ballet-jimani.ba05fbb1.webm";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-5f6320c8f05073561116.js